'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../../../tslib.es6-130a177d.js');
var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var SvgSaleBadge = function (props) {
    var className = props.className;
    var svgProps = tslib_es6.__assign(tslib_es6.__assign({}, props), { className: '' });
    return (React__default['default'].createElement("div", { className: className },
        React__default['default'].createElement("svg", tslib_es6.__assign({ viewBox: "0 0 25 45", height: "100%", width: "100%", fill: "currentColor" }, svgProps),
            React__default['default'].createElement("g", { fillRule: "evenodd" },
                React__default['default'].createElement("path", { d: "M25 34.5V.5H0v34l13.043 10z" }),
                React__default['default'].createElement("path", { fill: "#fff", fillRule: "nonzero", d: "M9.439 17.921a2.554 2.554 0 0 1-2.565-2.565 2.554 2.554 0 0 1 2.565-2.565 2.566 2.566 0 0 1 2.565 2.565 2.566 2.566 0 0 1-2.565 2.565zm-.798 7.866l6.517-12.597c.076-.133.171-.19.323-.19h.304c.285 0 .456.266.323.513L9.553 26.11a.37.37 0 0 1-.323.19h-.266c-.285 0-.456-.266-.323-.513zm.798-8.949c.779 0 1.444-.646 1.444-1.482 0-.779-.665-1.444-1.444-1.444-.836 0-1.482.665-1.482 1.444a1.46 1.46 0 0 0 1.482 1.482zm3.439 7.106a2.554 2.554 0 0 1 2.565-2.565 2.566 2.566 0 0 1 2.565 2.565 2.566 2.566 0 0 1-2.565 2.565 2.554 2.554 0 0 1-2.565-2.565zm1.083 0a1.46 1.46 0 0 0 1.482 1.482c.779 0 1.444-.646 1.444-1.482 0-.779-.665-1.444-1.444-1.444-.836 0-1.482.665-1.482 1.444z" })))));
};

exports.default = SvgSaleBadge;
//# sourceMappingURL=index.js.map
